<template>
  <div class="banner">
    <el-carousel v-if="bannerImgs.length > 0" :interval="5000" indicator-position="none" arrow="hover">
      <el-carousel-item v-for="(item, index) in bannerImgs" :key="index">
        <el-image :src="baseApiURL + item">
          <template v-slot:error>
            <img :src="require('../assets/index/topbannerys.png')" style="width: 100vw;" />
          </template>
        </el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
  <img src="../assets/index/1.png" class="banner_img">
  <img src="../assets/index/topBack.png" class="banner_bottom">
  <el-row>
    <el-col :span="3" class="left-side-bg"></el-col>
    <el-col :span="18" class="center-side-bg">
      <div class="node-show">
        <div class="node-show-title">
          <div class="node-show-title-en">
            <div>{{ scenicInfo.node_name_en }}</div>
          </div>
          <div class="node-show-title-ch"><img src="../assets/index/node1.png"></div>
          <div class="node-show-title-pw">
            <img :src="require('../assets/index/seal.png')" />
          </div>
        </div>
        <div class="node-show-button">
          <div v-for="(item, index) in scenicInfoButtons" :key="index"
            @mouseout="scenicInfoButtons[index].is_select = false" @mouseover="scenicInfoButtons[index].is_select = true"
            @click="handleProductClick(item.url)">
            <img :src="item.img_url" v-if="!item.is_select" alt="" />
            <img :src="item.img_url_select" v-else alt="" />
            <span>{{ item.name }}</span>
          </div>
        </div>
        <!--        封面图-->
        <div class="node-show-cover-pic">
          <el-image :src="baseApiURL + scenicInfo.top_banner_img_uuid" :lazy="true" class="boss_img">
            <template v-slot:error>
              <img loading="lazy" :src="require('../assets/index/indexError.jpg')" />
            </template>
          </el-image>
          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cs_span">{{ scenicInfo.description.substr(0,
            4)
          }}</span>{{ scenicInfo.description.slice(4) }}</div>
        </div>
      </div>
      <div class="node-show">
        <div class="node-show-title">
          <div class="node-show-title-en">
            <div>{{ canalInfo.node_name_en }}</div>
          </div>
          <div class="node-show-title-ch"><img src="../assets/index/node2.png"></div>
          <div class="node-show-title-pw">
            <img :src="require('../assets/index/seal.png')" />
          </div>
        </div>
        <div class="yuanhu"></div>
        <div class="node-show-data">
          <div class="node-show-data-left">
            <div :class="item.checked ? 'active' : 'noactive'" v-for="(item, index) in canalInfo.leftButton" :key="index"
              @click="handleDataType(index)">
              <span>{{ item.title_ch }}</span>
            </div>
          </div>
          <div class="node-show-data-right">
            <!-- <div class="node-show-data-right-title">
              <span class="node-show-data-right-title-ch" v-text="canalInfo.data.title_ch"></span>
              <span class="node-show-data-right-title-en" v-text="canalInfo.data.title_en"></span>
            </div> -->
            <div v-if="canalInfo.data.list.length > 0" class="node-show-data-right-list">
              <div class="node-show-data-right-first" @click="
                handleArticleDetail(
                  canalInfo.data.list[0].data_type,
                  canalInfo.data.list[0].int_id
                )
                ">
                <el-image class="node-show-data-right-first-top" :lazy="true"
                  :src="baseApiURL + canalInfo.data.list[0].font_img_id">
                  <template v-slot:error>
                    <img loading="lazy" :src="require('../assets/index/default.png')
                      " />
                  </template>
                </el-image>
                <div class="article_text">
                  <div>
                    <span class="node-show-data-right-first-title line-ellipsis">{{ canalInfo.data.list[0].title }}</span>
                    <span class="node-show-data-right-first-time">{{
                      canalInfo.data.list[0].create_time.substr(0, 10)
                    }}</span>
                  </div>
                  <p class="node-show-data-right-first-txt">
                    {{ canalInfo.data.list[0].txt_content }}
                  </p>
                  <img src="../assets/index/more03.jpg" class="more_img">
                  <div class="more_img_title">详情</div>
                </div>
              </div>
              <div v-if="canalInfo.data.list.length > 1" class="node-show-data-right-list-three">
                <div v-for="(item, index) in canalInfo.data.list.slice(1)" :key="index"
                  @click="handleArticleDetail(item.data_type, item.int_id)" class="node-show-data-right-list-three-item">
                  <div class="time_title">
                    <div class="-three-item-left">
                      <span class="-three-item-day">{{
                        item.create_time.substr(8, 2)
                      }}</span>
                      <span class="-three-item-month">{{
                        item.create_time.substr(0, 4) + '/' + item.create_time.substr(5, 2)
                      }}</span>
                    </div>
                    <div class="-three-item-right">
                      <span class="-three-item-title">{{
                        item.title
                      }}</span>
                      <span class="-three-item-txt line-ellipsis">{{
                        item.txt_content
                      }}</span>
                    </div>
                  </div>

                  <div class="-three-item-top-img">详情</div>
                </div>
              </div>
            </div>

            <el-empty v-else description="文章还没有发布哦"></el-empty>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="3" class="right-side-bg"></el-col>
  </el-row>

  <!--  一站式服务  -->
  <!-- <div class="yzs-banner" :style="{ background: yzs_banner_bg }">
    <span class="yzs-banner-txt">一站式服务</span>
  </div> -->
  <el-row>
    <el-col :span="3"></el-col>
    <el-col :span="18">
      <div class="yzs-node-show">
        <div class="node-show-title">
          <div class="node-show-title-en">
            <div>{{ yzsInfo.node_name_en }}</div>
          </div>
          <div class="node-show-title-ch"><img src="../assets/index/node3.png"></div>
          <div class="node-show-title-pw">
            <img :src="require('../assets/index/seal.png')" />
          </div>
        </div>
        <div class="yzs-node-show-button">
          <template v-for="(item, index) in yzsButtons" :key="index">
            <div class="yzs-node-show-button-item" @click="handleProductButtonClick(item)">
              <div class="animation" v-if="item.name == '特色美食'">吃</div>
              <div class="animation" v-else-if="item.name == '住宿推荐'">住</div>
              <div class="animation" v-else-if="item.name == '玩转江村'">玩</div>
              <div class="animation" v-else-if="item.name == '购物风趣'">购</div>
              <div class="animation" v-else-if="item.name == '如何抵达'">行</div>
              <img :src="item.img_url_dl" />
              <span>{{ item.name }}</span>
            </div>
          </template>
        </div>

        <!-- <div class="yzs-node-show-list">
          <div
            class="yzs-node-show-list-item"
            :style="{ backgroundImage: 'url(' + item.image_url + ')' }"
            v-for="(item, index) in yzsInfo.productList"
            :key="index"
            @click="handleProductClick(item.detail_url)"
          >
            <div class="yzs-node-show-list-item-info">
              <span class="line-ellipsis">{{ item.title }}</span>
              <p>{{ item.sell_point }}</p>
            </div>
          </div>
          <el-empty
            v-if="yzsInfo.productList.length == 0"
            description="商品还没有发布哦"
          ></el-empty>
        </div>

        <div class="yzs-node-show-more">
          <el-link
            :underline="false"
            :href="yzsInfo.more_goods"
            target="_blank"
          >
            查看更多
          </el-link>
        </div> -->
      </div>
    </el-col>
    <el-col :span="3"></el-col>
  </el-row>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      baseApiURL: this.$baseApiURL + '/api/v1/file/download?uuid=',
      yzs_banner_bg: '',
      bannerImgs: [],//首页轮播图
      // 景区介绍
      // 初识江村
      scenicInfo: {
        parent_id: '',
        parent_node_name: '',
        parent_previewURL: '',

        int_id: '',
        node_name: '初识江村',
        node_name_en: 'INTRODUCTION',
        description: '',
        previewURL: '',
        top_banner_img_uuid: '',
      },
      scenicInfoButtons: [
        {
          name: '景区导览',
          is_select: false,
          img_url: require('../assets/index/guide.svg'),
          img_url_select: require('../assets/index/guideActive.svg'),
          url: '/panoramicTour/index/171',
        },
        {
          name: '语音讲解',
          is_select: false,
          img_url: require('../assets/index/voice.svg'),
          img_url_select: require('../assets/index/voiceActive.svg'),
          url: '/article/listDetail/167',
        },
        {
          name: '影像中心',
          is_select: false,
          img_url: require('../assets/index/image.svg'),
          img_url_select: require('../assets/index/imageActive.svg'),
          url: '/videoAppreciation/index/235',
        },
        {
          name: '交通指引',
          is_select: false,
          img_url: require('../assets/index/traffic.svg'),
          img_url_select: require('../assets/index/trafficActive.svg'),
          url: '/article/listDetail/207',
        },
        {
          name: '在线预订',
          is_select: false,
          img_url: require('../assets/index/order.svg'),
          img_url_select: require('../assets/index/orderActive.svg'),
          url: '/onlineBooking/index',
        },
      ],

      yzsButtons: [
        {
          name: '特色美食',
          is_select: false,
          img_url_dl: require('../assets/index/eat.png'),
          img_url: require('@/assets/index/icon/shouye_canyinyuding.svg'),
          img_url_select: require('@/assets/index/icon/shouye_canyinyuding-xuanzhong.svg'),
          url: 'https://shop97220858.youzan.com/v2/showcase/tag?alias=1ylmlgubbwh5e',
          tag_id: '/article/list/176',
        },
        {
          name: '住宿推荐',
          is_select: false,
          img_url_dl: require('../assets/index/live.png'),
          img_url: require('@/assets/index/icon/shouye_jiudianyuding.svg'),
          img_url_select: require('@/assets/index/icon/shouye_jiudianyuding-xuanzhong.svg'),
          url: 'https://shop97220858.youzan.com/v2/showcase/tag?alias=1yah8ww5cgj5u',
          tag_id: '/article/list/178',
        },
        {
          name: '玩转江村',
          is_select: false,
          img_url_dl: require('../assets/index/play.png'),
          img_url: require('@/assets/index/icon/shouye_youlexiangmu.svg'),
          img_url_select: require('@/assets/index/icon/shouye_youlexiangmu-xuanzhong.svg'),
          url: 'https://shop97220858.youzan.com/v2/showcase/tag?alias=360r3iq64insy',
          tag_id: '/article/list/168',
        },
{
          name: '购物风趣',
          is_select: false,
          img_url_dl: require('../assets/index/buy.png'),
          img_url: require('@/assets/index/icon/shouye_shangpinyuding.svg'),
          img_url_select: require('@/assets/index/icon/shouye_shangpinyuding-xuanzhong.svg'),
          url: 'https://shop97220858.youzan.com/v2/showcase/tag?alias=3epl5fpmfcjk2',
          tag_id: '/onlineBooking/index#specialty',
        },
 {
          name: '如何抵达',
          is_select: false,
          img_url_dl: require('../assets/index/go.png'),
          img_url: require('@/assets/index/icon/shouye_menpiaoyuding.svg'),
          img_url_select: require('@/assets/index/icon/shouye_menpiaoyuding-xuanzhong.svg'),
          url: 'https://shop97220858.youzan.com/v2/showcase/tag?alias=3f0ornkzfttki',
          tag_id: '/article/listDetail/207',
        },
        // {
        //   name: '导游预订',
        //   is_select: false,
        //   img_url_dl: require('@/assets/index/dl_dyyd.png'),
        //   img_url: require('@/assets/index/icon/shouye_daoyoufuwu.svg'),
        //   img_url_select: require('@/assets/index/icon/shouye_daoyoufuwu-xuanzhong.svg'),
        //   url: 'https://shop97220858.youzan.com/v2/showcase/tag?alias=274cb8e2okhiq',
        //   tag_id: '168906599',
        // },
      ],

      // 运河资讯
      canalInfo: {
        parent_id: '',
        parent_node_name: '',
        parent_previewURL: '',

        int_id: '',
        node_name: '资讯动态',
        node_name_en: 'INFROMATTON',
        description: '',
        previewURL: '',
        top_banner_img_uuid: '',
        // 左侧按钮
        leftButton: [
          {
            nodeId: '183',
            title_ch: '最新动态',
            title_en: 'NEWS',
            checked: true,
          },
          {
            nodeId: '184',
            title_ch: '精品活动',
            title_en: 'ACTIVITY',
            checked: false,
          },
          {
            nodeId: '182',
            title_ch: '景区公告',
            title_en: 'NOTICE',
            checked: false,
          },
        ],
        data: {
          title_ch: '最新动态',
          title_en: 'NEWS',
          list: [
            {
              int_id: 6,
              time_stamp: '2021/07/06 16:10:50',
              create_time: '2021/07/06 04:10:04',
              title: '景区公告 第一条',
              content:
                '<h2 id="color-se-cai" style="font-size: 28px; color: rgb(31, 47, 61); margin: 0px; font-weight: 400; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;">Color 色彩</h2><p style="font-size: 14px; color: rgb(94, 109, 130); line-height: 1.5em; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;">Element 为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。</p><h3 id="zhu-se" style="font-size: 22px; font-weight: 400; color: rgb(31, 47, 61); margin: 55px 0px 20px; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;"><a href="https://element.faas.ele.me/#/zh-CN/component/color#zhu-se" aria-hidden="true" class="header-anchor" style="color: rgb(64, 158, 255); text-decoration-line: none; float: left; margin-left: -20px; opacity: 0; cursor: pointer;">&para;</a></h3><h2 id="color-se-cai" style="font-size: 28px; color: rgb(31, 47, 61); margin: 0px; font-weight: 400; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;">Color 色彩</h2><p style="font-size: 14px; color: rgb(94, 109, 130); line-height: 1.5em; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;">Element 为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。</p><h3 id="zhu-se" style="font-size: 22px; font-weight: 400; color: rgb(31, 47, 61); margin: 55px 0px 20px; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;"><a href="https://element.faas.ele.me/#/zh-CN/component/color#zhu-se" aria-hidden="true" class="header-anchor" style="color: rgb(64, 158, 255); text-decoration-line: none; float: left; margin-left: -20px; opacity: 0; cursor: pointer;">&para;</a></h3><h2 id="color-se-cai" style="font-size: 28px; color: rgb(31, 47, 61); margin: 0px; font-weight: 400; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;">Color 色彩</h2><p style="font-size: 14px; color: rgb(94, 109, 130); line-height: 1.5em; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;">Element 为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。</p><h3 id="zhu-se" style="font-size: 22px; font-weight: 400; color: rgb(31, 47, 61); margin: 55px 0px 20px; font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif; white-space: normal;"><a href="https://element.faas.ele.me/#/zh-CN/component/color#zhu-se" aria-hidden="true" class="header-anchor" style="color: rgb(64, 158, 255); text-decoration-line: none; float: left; margin-left: -20px; opacity: 0; cursor: pointer;">&para;</a></h3><p><br/></p>',
              txt_content:
                'Color 色彩Element 为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。&para;Color 色彩Element 为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。&para;Color 色彩Element 为了避免视觉传达差异，使用一套特定的调色板来规定颜色，为你所搭建的产品提供一致的外观视觉感受。&para;',
              font_img_id: 'd249eff5-41f1-41c0-b6a4-be8fc0d4126f',
              font_img_mark_id: 'd249eff5-41f1-41c0-b6a4-be8fc0d4126f',
              file_ids: '',
              file_mark_ids: '',
              data_type: 182,
              user_id: 1,
              file_mark_list: null,
              font_img_mark: null,
              file_list: null,
              font_img: null,
              taxis: 6,
              previewURL: null,
              is_wave_show: '0',
            },
          ],
        },
      },
      yzsInfo: {
        //商品列表
        productList: [],
        more_goods: '',
        node_name: '旅行服务',
        node_name_en: 'INFROMATTON',
      },
      rightWindows: {
        data: {
          YiQing: {
            dayMaxAllowVisitorNum: 10000,
            millMaxAllowVisitorNum: 5000,
          },
          ChangGui: {
            dayMaxAllowVisitorNum: 10000,
            millMaxAllowVisitorNum: 5000,
          },
          realTimeVisitorNum: 0,
          realTimeRestParkingNum: 100,
          comfort: '舒适', //舒适度
        },
        orderQRShow: false,
      },
    }
  },
  methods: {
    async getNodeAndParent(nodeId) {
     let result = await this.$apiUtil.getNodeAndParent(nodeId)
    //  result.result.map(item => ({
    //   description: item.description,
    //   int_id: item.int_id,
    //   node_name: "初识江村",
    //   node_name_en: "INTRODUCTION",
    //   parent_id: item.parent_id,
    //   parent_node_name: item.parent_node_name,
    //   parent_previewURL: item.parent_previewURL,
    //   previewURL: item.previewURL,
    //   top_banner_img_uuid:item.top_banner_img_uuid,
    //   }))
      if (result.returnCode === 1 && result.result) {
        this.scenicInfo = result.result
      } else {
        this.scenicInfo.node_name = '栏目不存在'
        this.$message.error(result.description)
      }
    },
    handleArticleDetail(nodeId, articleId) {
      //第一步定义routeUrl
      let routeUrl = this.$router.resolve({
        path: '/article/detail/' + nodeId + '/' + articleId,
      })
      // 第二步：新标签页打开
      window.open(routeUrl.href, '_blank')
    },
    async getTopBanner(nodeId) {
      let result = await this.$apiUtil.getCommonArticlePage(nodeId, 1, 1, '')
      if (
        result.returnCode === 1 &&
        result.result &&
        result.result.list.length > 0
      ) {
        this.bannerImgs = result.result.list[0].file_ids.split(',')
      }
    },
    async getCommonArticlePage(nodeId) {
      let result = await this.$apiUtil.getCommonArticlePage(nodeId, 1, 4, '')
      if (result.returnCode === 1 && result.result) {
        this.canalInfo.data.list = result.result.list
      }
    },
    handleDataType(index) {
      this.canalInfo.leftButton.forEach((item) => {
        item.checked = false
      })

      let _button = this.canalInfo.leftButton[index]
      _button.checked = true
      this.canalInfo.data.title_ch = _button.title_ch
      this.canalInfo.data.title_en = _button.title_en
      this.getCommonArticlePage(_button.nodeId)
    },
    handleProductButtonClick(button) {
      this.$router.push(button.tag_id)
    },
    handleProductClick(url) {
      if (url === '') {
        this.$message.error('敬请期待')
        return
      }

      window.open(url, '_blank')
    },
    handleShowQR() {
      this.rightWindows.orderQRShow = !this.rightWindows.orderQRShow
    },
    async getGoodsList(tag_id) {
      let result = await this.$apiUtil.yzGoodsApi.getGoodsList(1, 4, tag_id, '')
      if (result.returnCode === 1 && result.result) {
        this.yzsInfo.productList = result.result.list
      }
    },
    init() {
      this.getTopBanner(232)

      // 景区介绍
      this.getNodeAndParent(41)
      this.getCommonArticlePage(this.canalInfo.leftButton[0].nodeId)

      // this.handleProductButtonClick(this.yzsButtons[0]);
    },
  },
  mounted() {
    this.init()
  },
  setup() {
    const title = '首页'

    return {
      title,
    }
  },
}
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  min-height: 990px;
  margin-bottom: 100px;
  position: relative;

  ::v-deep(.el-carousel__container) {
    height: 990px;
  }

  .banner-txt-1,
  .banner-txt-2 {
    position: absolute;
    writing-mode: tb;
    width: 100px;
    height: 560px;
    font-size: 100px;
    font-family: MaShanZhengMaoBiKaiTi, serif !important;
    font-weight: 500;
    color: #ffffff;
    z-index: 10;
  }

  .banner-txt-1 {
    top: 220px;
    left: 52%;
  }

  .banner-txt-2 {
    top: 120px;
    left: 43%;
  }
}

.banner_img {
  position: absolute;
  top: 400px;
  left: 450px;
}

.banner_bottom {
  width: 100vw;
  position: absolute;
  top: 570px;
  left: 0;
}

.right-window-div1 {
  width: 188px;
  height: 220px;
  display: block;
  top: 550px;
  right: 180px;
  position: absolute;
  background: url('../assets/index/bg_window_1.png') no-repeat;
  background-size: 188px 220px;
  text-align: center;
  cursor: pointer;
  z-index: 3;

  .el-image {
    width: 142px;
    height: 142px;
    margin: 23px 23px 10px 23px;
  }

  span {
    line-height: 18px;
    font-size: 18px;
    font-family: SourceHanSansCN-Regular, serif;
    font-weight: 400;
    color: #ffffff;
    text-shadow: 0px 6px 10px rgba(34, 102, 149, 0.59);
  }
}

.right-window {
  width: 400px;
  height: 250px;
  top: 730px;
  right: 0;
  position: absolute;
  z-index: 3;
  //background: #333333;

  .right-window-div2 {
    width: 212px;
    height: 83px;
    background: url('../assets/index/bg_window_2.png') no-repeat;
    background-size: 212px 83px;
    text-align: center;
    margin-left: 20px;
    margin-top: 22px;
    position: absolute;
    cursor: pointer;

    span {
      width: 72px;
      height: 18px;
      line-height: 83px;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular, serif;
      font-weight: 400;
      color: #ffffff;
      text-shadow: 0px 6px 10px rgba(34, 102, 149, 0.59);
    }

    .right-window-div2-arrow-up {
      width: 16px;
      height: 16px;
      margin-top: 32px;
      margin-left: 10px;
    }

    .transform {
      transform: rotate(180deg);
    }
  }

  .right-window-div3 {
    z-index: 3;
    width: 419px;
    height: 266px;
    background: url('../assets/index/bg_window_3.png') no-repeat;
    background-size: 419px 266px;

    .right-window-div3-carousel {
      position: relative;
      width: 300px;
      height: 100px;
      top: 100px;
      text-align: left;

      ::v-deep(.el-carousel__container) {
        height: 100px;
      }

      .carousel-div {
        width: 240px;
        margin-left: 60px;
        color: #ffffff;

        p {
          margin: 5px 0;
          text-shadow: 0px 6px 10px rgba(10, 103, 166, 0.59);

          span {
            font-size: 20px;
          }
        }

        .carousel-title {
          font-size: 18px;
        }
      }
    }
  }
}

.left-side-bg {
  background-image: url('../assets/index/lianhua.png');
  background-repeat: no-repeat;
  background-position: 120% 100%;
  // background-size: 56px 331px;
}

// .center-side-bg {
//   background-image: url('../assets/index/bg_right_3.png');
//   background-size: 36px 240px;
//   background-repeat: no-repeat;
//   background-position: 80% 60%;
// }

.right-side-bg {
  background-image: url('../assets/index/lianhua.png');
  background-repeat: no-repeat;
  background-position: 0 35%;
  // background-size: 82px 384px;
}

// .el-col-3 {
//   background-image: url('../assets/index/lianhua.png');
//   background-repeat: no-repeat;
//   // background-position: 0 35%;
// }

.node-show {
  margin-top: 100px;

  .node-show-title {
    user-select: none;

    >div {
      display: inline-flex;
      writing-mode: vertical-lr;
      text-align: left;
    }

    .node-show-title-en {
      height: 113px;
      font-size: 14px;
      font-family: SourceHanSerifCN-Regular;
      font-weight: 400;
      color: #002945;
      display: inline-flex;
      justify-content: space-around;

      div {
        height: 80px;
      }

      img {
        width: 13px;
        height: 20px;
      }
    }

    .node-show-title-ch {
      height: 109px;
      font-size: 48px;
      font-family: MaShanZhengMaoBiKaiTi;
      font-weight: bold;
      color: #002945;
      line-height: 62px;
    }

    .node-show-title-pw {
      width: 105px;
      height: 125px;
      font-size: 28px;
      font-family: SourceHanSerifCN-Regular;
      color: #002945;
      line-height: 180px;
      // background: url('../assets/index/pw_cloud.png') no-repeat bottom;
      background-size: 105px 46px;

      img {
        width: 28px;
        height: 39px;
      }
    }
  }

  .node-show-button {
    margin-top: 50px;

    >div {
      width: 90px;
      display: inline-block;
      margin: 10px 90px;
      cursor: pointer;

      >img {
        width: 80px;
        height: 82px;
      }

      >span {
        margin-top: 14px;
        line-height: 16px;
        display: inline-block;
        width: 90px;
        height: 21px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: black;
      }
    }
  }

  .node-show-cover-pic {
    display: flex;
    height: 500px;
    overflow: hidden;
    text-align: left;
    line-height: 32px;

    .boss_img {
      width: 630px;
      height: 450px;
      margin-top: 50px;
    }

    >div {
      margin-top: 180px;
      margin-left: 80px;
      width: 650px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }

    .cs_span {
      width: 121px;
      height: 30px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      color: #333333;
      line-height: 36px;
      text-shadow: 0px 3px 4px rgba(14, 47, 55, 0.45);
      background: linear-gradient(0deg, #16909B 0%, #10333E 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .node-show-desc {
    width: 1353px;
    margin: auto;
    padding-bottom: 70px;
    text-align: initial;
    text-indent: 2em;
    font-size: 20px;
    font-family: SourceHanSerifCN-Regular, serif;
    line-height: 40px;
    color: #002945;
  }

  .node-show-desc:first-letter {
    font-size: 58px;
    font-family: MaShanZhengMaoBiKaiTi;
    font-weight: 400;
    color: #002945;
  }

  .yuanhu {
    width: 100%;
    height: 290px;
    border-top: 2px solid #999999;
    border-radius: 50% 50% 0 0;
    overflow: hidden;
    position: absolute;
    top: 1272px;
    left: 0;
  }

  .node-show-data {
    overflow: hidden;
    position: relative;

    .node-show-data-left {
      // display: inline-block;
      display: flex;
      justify-content: space-evenly;
      margin-top: 100px;
      margin-bottom: 100px;

      .noactive {
        width: 54px;
        height: 54px;
        padding: 3px;
        text-align: center;
        font-family: SXSGYS;
        border: 1px solid #999999;
        border-radius: 50%;
        background: white;
        cursor: pointer;

        span {
          font-size: 19px;
          color: #333333;
        }
      }

      .active {
        width: 54px;
        height: 54px;
        padding: 3px;
        text-align: center;
        border: 1px solid #999999;
        border-radius: 50%;
        background: rgb(45, 125, 139);
        cursor: pointer;

        span {
          font-size: 19px;
          color: white;
        }
      }

      .select {
        >div {
          background: rgb(45, 125, 139);

          span {
            color: white;
          }
        }
      }
    }

    .node-show-data-right {
      width: 90%;
      display: inline-block;
      float: right;

      .node-show-data-right-title {
        width: 100%;
        text-align: left;

        .node-show-data-right-title-ch {
          width: 91px;
          font-size: 44px;
          font-family: SourceHanSerifCN-Regular, serif;
          font-weight: bold;
          color: #002945;
          line-height: 93px;
        }

        .node-show-data-right-title-en {
          margin-left: 30px;
          width: 115px;
          height: 24px;
          font-size: 30px;
          font-family: SourceHanSansCN-Regular, serif;
          font-weight: bold;
          color: #6f7d86;
          line-height: 62px;
        }
      }

      .node-show-data-right-list {
        text-align: initial;

        .node-show-data-right-first {
          // width: 900px;
          height: 560px;
          display: flex;
          // display: inline-block;

          .node-show-data-right-first-top {
            width: 600px;
            height: 500px;
            margin-bottom: 25px;
            text-align: center;
          }

          .article_text {
            width: 600px;
            height: 500px;
            background: rgb(22, 144, 155);
            box-sizing: border-box;
            padding: 40px;
          }

          .node-show-data-right-first-title {
            // width: 60%;
            width: 500px;
            line-height: 20px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: white;
            display: inline-block;
            text-align: left;
            margin-bottom: 10px;
          }

          .node-show-data-right-first-time {
            // width: 40%;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #FCFCFC;
            line-height: 20px;
            display: inline-block;
            text-align: right;
          }

          .node-show-data-right-first-txt {
            text-align: initial;
            margin-top: 25px;
            // width: 100%;
            height: 180px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: white;
            line-height: 30px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
            text-indent: 2em;
            margin-bottom: 60px;
          }

          .more_img {
            width: 117px;
            height: 39px;
            cursor: pointer;
            position: relative;
          }

          .more_img_title {
            position: absolute;
            top: 628px;
            left: 820px;
            color: #16909B;
            font-size: 20px;
            font-weight: 600;
          }
        }

        .node-show-data-right-list-three {
          width: 350px;
          height: 300px;
          // float: right;
          // display: inline-block;
          display: flex;
          text-align: initial;

          .node-show-data-right-list-three-item {
            width: 350px;
            height: 80px;
            margin-top: 10px;
            margin-bottom: 120px;
            margin-right: 100px;
            text-align: left;

            .time_title {
              display: flex;
            }

            .-three-item-top-img {
              width: 117px;
              height: 39px;
              text-align: center;
              line-height: 39px;
              color: white;
              font-size: 20px;
              font-weight: 600;
              background-image: url("../assets/index/more.jpg");
              background-size: 117px 39px;
              margin-left: 100px;
              cursor: pointer;
            }

            .-three-item-left {
              width: 100px;

              .-three-item-day {
                font-size: 48px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #333333;
                display: block;
              }

              .-three-item-month {
                display: block;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #333333;
              }
            }

            .-three-item-right {
              display: inline-block;
              width: 250px;
              margin-top: 20px;

              .-three-item-title {
                width: 100%;
                height: 60px;
                display: inline-block;
                font-weight: bold;
                color: black;
                margin-bottom: 20px;
              }

              .-three-item-txt {
                width: 100%;
                height: 16px;
                display: inline-block;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
                line-height: 16px;
                margin-bottom: 60px;
              }
            }
          }

          .node-show-data-right-list-three-item:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

// .yzs-banner {
//   margin-top: 100px;
//   height: 367px;
//   width: 100%;
//   // background: url("../assets/index/yzs_banner.png") no-repeat;

//   .yzs-banner-txt {
//     line-height: 367px;
//     font-size: 190px;
//     font-family: MaShanZhengMaoBiKaiTi, serif !important;
//     color: #002945;
//   }
// }

.yzs-node-show {
  margin-top: 100px;
  margin-bottom: 200px;

  .node-show-title {
    margin-bottom: 100px;

    >div {
      display: inline-flex;
      writing-mode: vertical-lr;
      text-align: left;
    }

    .node-show-title-en {
      height: 150px;
      font-size: 14px;
      font-family: SourceHanSerifCN-Regular;
      font-weight: 400;
      color: #002945;

      display: inline-flex;
      justify-content: space-around;

      div {
        height: 80px;
      }

      img {
        width: 13px;
        height: 20px;
      }
    }

    .node-show-title-ch {
      height: 109px;
      font-size: 48px;
      font-family: MaShanZhengMaoBiKaiTi;
      font-weight: bold;
      color: #002945;
      line-height: 62px;
    }

    .node-show-title-pw {
      width: 109px;
      height: 150px;
      font-size: 28px;
      font-family: SourceHanSerifCN-Regular;
      color: #002945;
      line-height: 180px;
      // background: url('../assets/index/pw_cloud.png') no-repeat bottom;
      background-size: 105px 46px;

      img {
        width: 28px;
        height: 39px;
      }
    }
  }

  .yzs-node-show-button {
    width: 1500px;
    height: 500px;
    margin-top: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url("../assets/index/scroll.png");
    background-size: 1500px 500px;

    .yzs-node-show-button-item {
      width: 210px;
      height: 280px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      margin-right: 30px;
      border: 2px solid rgb(175, 169, 159);
      border-radius: 10px;
    }

    img {
      width: 150px;
      height: 210px;
      margin-bottom: 20px;
      display: block;
      cursor: pointer;
      position: relative;
    }

    .animation {
      width: 150px;
      height: 210px;
      margin-bottom: 20px;
      line-height: 210px;
      font-size: 40px;
      font-weight: 500;
      color: transparent;
      cursor: pointer;
      position: absolute;
      z-index: 100;
    }

    .animation:hover {
      width: 150px;
      height: 210px;
      margin-bottom: 20px;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.5);
      background-image: url("../assets/index/animation.png");
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 100px 100px;
      line-height: 210px;
      font-size: 40px;
      font-family: FZXingKai-S04S;
      font-weight: 400;
      color: #FBFBFB;
    }

    span {
      cursor: pointer;
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, serif;
      font-weight: 400;
      color: #002945;
      display: block;
    }
  }

  .yzs-node-show-list {
    margin: 20px 0;
    // 旅游指南

    .yzs-node-show-list-item:hover {
      cursor: pointer;
    }

    .yzs-node-show-list-item:hover .yzs-node-show-list-item-info {
      display: inline-block;
    }

    .yzs-node-show-list-item {
      margin: 0 1%;
      width: 300px;
      height: 300px;
      display: inline-block;
      background-size: 300px 300px;
      text-align: initial;

      .yzs-node-show-list-item-info {
        width: 300px;
        height: 300px;
        text-align: center;
        position: absolute;
        display: none;
        background-color: rgb(0 0 0 / 50%);

        >span {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
          line-height: 100px;
        }

        >p {
          margin: auto;
          width: 80%;
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          line-height: 30px;
          text-align: initial;
          text-indent: 2em;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          overflow: hidden;
        }
      }
    }
  }

  .yzs-node-show-more {
    background: url('../assets/index/yzs_more_bg.png') no-repeat bottom;
    height: 40px;
    margin-top: 20px;

    >a {
      width: 73px;
      height: 17px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
      cursor: pointer;
    }
  }
}
</style>
